import { useMemo } from "react"
import { useProducts } from "@/app/wadmin/products/useProducts"
import { useMarketplaceListings } from "./useMarketplaceListings"
import { ProductWithListing } from "../types"

export function useProductsWithListings(address?: string | string[]) {
  const { data: products, isLoading: productsLoading } = useProducts()
  const { listings, isLoading: listingsLoading } = useMarketplaceListings()

  const productsWithListings = useMemo(() => {
    if (!products) { return [] }

    const addressArray = address
      ? Array.isArray(address)
        ? address.map((a) => a.toLowerCase())
        : [address.toLowerCase()]
      : undefined

    return products.map((product): ProductWithListing => {
      const productListings = listings.filter((listing) => {
        const matchesProductType = listing.productType === product.productType
        const matchesToken = listing.tokenId === product.tokenId
        const matchesAddress = addressArray
          ? addressArray.includes(listing.listingCreator.toLowerCase())
          : true

        return matchesProductType && matchesToken && matchesAddress
      })

      return {
        ...product,
        listings: productListings,
      }
    })
  }, [products, listings, address])

  return {
    products: productsWithListings,
    isLoading: productsLoading || listingsLoading,
  }
}
